// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtCardActivationResultModel {
    static getAttributeTypeMap() {
        return ExtCardActivationResultModel.attributeTypeMap;
    }
}
ExtCardActivationResultModel.discriminator = undefined;
ExtCardActivationResultModel.additionalProperties = false;
ExtCardActivationResultModel.attributeTypeMap = [
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "cardActivationDate",
        "baseName": "cardActivationDate",
        "type": "Date"
    },
    {
        "name": "cardEndDate",
        "baseName": "cardEndDate",
        "type": "Date"
    },
    {
        "name": "sponsorNumber",
        "baseName": "sponsorNumber",
        "type": "string"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "totalBenefitAmount",
        "baseName": "totalBenefitAmount",
        "type": "number"
    },
    {
        "name": "remainingBenefitAmount",
        "baseName": "remainingBenefitAmount",
        "type": "number"
    },
    {
        "name": "totalPaidAmount",
        "baseName": "totalPaidAmount",
        "type": "number"
    },
    {
        "name": "accumulators",
        "baseName": "accumulators",
        "type": ""
    },
];
//# sourceMappingURL=extCardActivationResultModel.js.map